var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeDefineProperty = getNative(Object, 'defineProperty');

module.exports = nativeDefineProperty;



//////////////////
// WEBPACK FOOTER
// ./~/swagger-client/~/lodash/_nativeDefineProperty.js
// module id = 768
// module chunks = 0